// ============================================================
// CENTRAL SITE CONFIGURATION
// Edit all hospital-specific details here. Every page, button,
// phone link and WhatsApp message reads from this file.
// ============================================================

export const SITE = {
  name: "Kasdol Multispeciality Hospital",
  shortName: "KMH",
  tagline: "Compassionate Care. Trusted Healthcare.",
  location: "Kasdol, Chhattisgarh, India",

  // Official contact numbers (do not add others)
  phoneDisplay: "+91 83492 47470",
  phoneRaw: "+918349247470",
  whatsapp: "918349247470", // country code + number, digits only

  // TODO: add the official email when the hospital provides one
  email: "",

  // TODO: add the exact street address when provided.
  // Until then only the locality is displayed.
  addressLine: "",
  city: "Kasdol",
  state: "Chhattisgarh",
  country: "India",
  mapQuery: "Kasdol, Chhattisgarh, India",

  // Set true ONLY if the hospital genuinely runs 24/7 emergency services
  emergency24x7: false,

  // DEMO timings — replace with the hospital's actual OPD hours
  hours: [
    { label: "OPD Consultations", value: "Mon – Sat · 10:00 AM – 2:00 PM", isDemo: true },
    { label: "Evening OPD", value: "Mon – Sat · 5:00 PM – 8:00 PM", isDemo: true },
  ],

  // Social profiles — paste URLs when available (placeholders render as #)
  socials: {
    facebook: "",
    instagram: "",
    youtube: "",
  },
};

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Doctors", path: "/doctors" },
  { name: "Services", path: "/services" },
  { name: "Facilities", path: "/facilities" },
  { name: "Appointment", path: "/appointments" },
  { name: "Contact", path: "/contact" },
];

export const fullAddress = () =>
  [SITE.addressLine, SITE.city, SITE.state, SITE.country].filter(Boolean).join(", ");
